import { Component, computed, input, output } from '@angular/core';
import { type AgendaBlockStatus } from './agenda-block.model';
import { IconComponent } from '../icon';

@Component({
  selector: 'lib-agenda-block',
  imports: [IconComponent],
  templateUrl: './agenda-block.component.html',
  styleUrls: [
    '../../tokens/colors.css',
    '../../tokens/agenda-block-tokens.css',
    './agenda-block.component.css',
  ],
  host: {
    '[class]': 'hostClasses()',
    '[attr.title]': 'tooltip() || null',
    '[attr.type]': 'bookable() ? "button" : null',
    '(click)': 'onBlockClick()',
    '(keydown.enter)': 'onBlockClick()',
    '(keydown.space)': 'onBlockClick()',
  },
})
export class AgendaBlockComponent {
  /** Primary label (e.g. client name, "Reservar"). */
  label = input.required<string>();

  /** Time range text (e.g. "08:00 - 10:00"). */
  time = input.required<string>();

  /** Status drives the color scheme. */
  status = input<AgendaBlockStatus>('disponible');

  /** When true, renders as a button with pointer cursor. */
  bookable = input<boolean>(false);

  /** When true (and not bookable), still shows a pointer cursor — e.g. an occupied block that opens a detail modal on click. */
  clickable = input<boolean>(false);

  /** Optional tooltip text. */
  tooltip = input<string>();

  /** When false, hides the label (e.g. client name, "Reservar"). */
  showLabel = input<boolean>(true);

  /** When false, hides the time range text. */
  showTime = input<boolean>(true);

  /** When true, shows a small repeat icon in the top-right corner marking this as part of a recurring series. */
  recurring = input<boolean>(false);

  /** Emits when the block is clicked (bookable or reserved). */
  clicked = output<void>();

  /** Repeat icon (two looping arrows) — universal symbol for a recurring/periodic event. */
  readonly repeatIconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 2l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';

  readonly hostClasses = computed(() => {
    const status = this.status();
    const bookable = this.bookable();
    return {
      'msa-ab': true,
      [`msa-ab--${status}`]: true,
      'msa-ab--bookable': bookable,
      'msa-ab--clickable': !bookable && this.clickable(),
      'msa-ab--time-only': this.showTime() && !this.showLabel(),
      'msa-ab--recurring': this.recurring(),
    };
  });

  onBlockClick(): void {
    this.clicked.emit();
  }
}
